const labels = {
  en: {
    "footer.copyright": "© Copyright {0} | Georgia County Poll Worker",

    "welcomePage.Title": "Georgia County Poll Worker",
    "welcomePage.Subtitle":
      "Your Journey, Our Responsibility: We've Got You Covered",

    "menu.home": "Home",
    "menu.cards": "Cards",
    "menu.queryAvailable": "Query available",
    "menu.queryAssigned": "Query assigned",
    "menu.requestNewOrder": "Request (New Order)",
    "menu.uploadCipFile": "Upload CIP File",
    "menu.uploadEwaCollections": "Upload EWA Collection Attempts File",
    "menu.assignCardOnTheFly": "Assign Card On-The-Fly (No Inventory)",
    "menu.locations": "Locations",
    "menu.viewDashboard": "View Dashboard",
    "menu.queryLocations": "Query Locations",
    "menu.payments": "Payments",
    "menu.manageBalances": "Manage balances",
    "menu.companyBalance": "Company Balance",
    "menu.companyBalances": "Company Balances",
    "menu.interCompanyTransfers": "Inter Company Transfers",
    "menu.paymentRequests": "Payment Requests",
    "menu.queryAll": "Query All",
    "menu.queryPending": "Query Pending",
    "menu.whitelist": "Whitelist",
    "menu.membersWorkers": "Members/ Workers",
    "menu.queryMembers": "Query Members",
    "menu.queryMemberInfoInternal": "Query Member Info (Internal)",
    "menu.queryTimeAttendance": "Query Time and Attendance",
    "menu.queryMissingTimeAttendance": "Query Missing Time and Attendance",
    "menu.payAnyDayDeduction": "Pay Any-Day - Payroll Deduction",
    "menu.onboarding": "Onboarding",
    "menu.queryPendingOnboardings": "Query Pending Onboardings (Review)",
    "menu.queryStartedOnboardings": "Query Started Onboardings",
    "menu.queryStartedOnboardingsRds": "Query Started Onboardings (RDS)",
    "menu.bulkOnboardings": "Bulk Onboardings",
    "menu.preauthorizedPadStandalone": "Preauthorized for PAD Standalone",
    "menu.configure": "Configure",
    "menu.manageEmployerConfig": "Manage Companies",
    "menu.companySettings": "Company Settings",
    "menu.paymentTypeConfig": "Payment Type Configuration",
    "menu.uploadSigningAuthority": "Upload Signing Authority",
    "menu.transactionFeeConfig": "Transaction Fee Configuration",
    "menu.manageCompanyMFA": "Manage Company MFA",
    "menu.setInactivityThreshold": "Set Inactivity Threshold",
    "menu.manageLoyaltyConfig": "Manage Loyalty Configuration",
    "menu.addLoyaltyMerchant": "Add Loyalty Merchant",
    "menu.manageGroups": "Manage Groups",
    "menu.manageCompanyGroups": "Company Groups",
    "menu.requestAccess": "Request Access",
    "menu.requestsAwaitingApproval": "Requests Awaiting Approval",
    "menu.manageGroupMembers": "Manage Group Members",
    "menu.reports": "Reports",
    "menu.campaignReports": "Campaign Reports",
    "menu.activationsReport": "Activations Report",
    "menu.reloadReport": "Reload Report",
    "menu.payAnyDayUsage": "Pay Any-Day - Usage Report",
    "menu.paymentReport": "Payment Report",
    "menu.activityReport": "Activity Report",
    "menu.organizationalUnits": "Organizational Units",
    "menu.configureOrgUnits": "Configure Organizational Units",
    "menu.assignOrgUnitMembers": "Assign Organizational Unit Members",
    "menu.rellevateLogo": "Rellevate Logo",
    "menu.loadingOrganization": "Loading organization...",
    "menu.organization": "Organization",
    "menu.user": "User",
    "menu.guest": "Guest",
    "menu.signOut": "SIGN OUT",
    "menu.paymentDescriptors": "Payment Descriptors",
    "menu.spendRules": "Spend Rules",
    "menu.campaigns": "Campaigns",
    "menu.cardsDashboard": "Cards Dashboard",
    "menu.flashReports": "Flash Reports",

    // QueryPaymentsSummary Labels
    "queryPaymentsSummary.PaymentRequests": "Payment Requests",
    "queryPaymentsSummary.error": "An error ocurred, please try again later...",

    // PaymentsSummary Labels
    "paymentsSummary.column.id": "ID",
    "paymentsSummary.column.idPayFile": "Id",
    "paymentsSummary.column.description": "Description",
    "paymentsSummary.column.idEmployer": "Employer",
    "paymentsSummary.column.numberOfRecords": "Records #",
    "paymentsSummary.column.totalAmount": "Total",
    "paymentsSummary.column.type": "Type",
    "paymentsSummary.column.processStatus": "Status/Action",
    "paymentsSummary.column.paymentDate": "Created At",
    "paymentsSummary.column.details": "Details",
    "paymentsSummary.department": "Department",
    "paymentsSummary.createPayFile": "Create Pay File",
    "paymentsSummary.uploadPayFile": "Upload Pay File",
    "paymentsSummary.generateTemplate": "Generate Template",
    "paymentsSummary.confirmSuccess": "The request was verified succesfully",
    "paymentsSummary.downloadSuccess": "The file was download succesfully",
    "paymentsSummary.downloadError":
      "There was an error trying to download the file",
    "paymentsSummary.viewTooltip": "Click to view more info of the request",
    "paymentsSummary.verifyTooltip": "Click to verify and accept the request",
    "paymentsSummary.cancelTooltip": "Click to cancel and close the request",
    // Onboardings Labels
    "onboardings.title": "OnBoarding Applications",
    "onboardings.loading": "Loading...",
    "onboardings.error": "An error ocurred, please try again later...",
    "onboardings.requestSent": "The request was sent",
    "onboardings.editDialogTitle": "Edit Onboarding",

    // Onboardings DataGrid Column Headers
    "onboardings.column.id": "ID",
    "onboardings.column.firstName": "First Name",
    "onboardings.column.lastName": "Last Name",
    "onboardings.column.email": "Email",
    "onboardings.column.dob": "DOB",
    "onboardings.column.address": "Address",
    "onboardings.column.phone": "Phone",
    "onboardings.column.ssn": "SSN",
    "onboardings.column.duration": "Duration",
    "onboardings.column.action": "Action",
    "onboardings.column.creationDate": "Creation Date",
    "onboardings.column.updateDate": "Update Date",

    // QueryTimeAttendance Labels
    "queryTimeAttendance.showPayPeriods": "Show Pay Periods",
    "queryTimeAttendance.timeAndAttendance": "Time And Attendance",

    // ManageWhitelist Labels
    "manageWhitelist.title": "Transfer to Rellevate whitelist",
    "manageWhitelist.addToWhitelist": "Add to whitelist",
    "manageWhitelist.error": "An error ocurred, please try again later...",
    "manageWhitelist.deleteTooltip": "Delete whitelist element",
    "manageWhitelist.addDialogTitle": "Add to whitelist",

    // ManageWhitelist DataGrid Column Headers
    "manageWhitelist.column.id": "idWhitelist",
    "manageWhitelist.column.employerName": "Company",
    "manageWhitelist.column.customerSender": "Sender",
    "manageWhitelist.column.recipientUsername": "Recipient user",
    "manageWhitelist.column.recipientName": "Recipient name",
    "manageWhitelist.column.status": "Status",
    "manageWhitelist.column.actions": "Actions",

    // QueryMultiBalance Labels
    "queryMultiBalance.departmentBalances": "Department Balances",
    "queryMultiBalance.creditsThisMonth": "Credits this month",
    "queryMultiBalance.creditsThisWeek": "Credits this week",
    "queryMultiBalance.creditsToday": "Credits today",
    "queryMultiBalance.debitsThisMonth": "Debits this month",
    "queryMultiBalance.debitsThisWeek": "Debits this week",
    "queryMultiBalance.debitsToday": "Debits today",
    "queryMultiBalance.error": "Error",
    "queryMultiBalance.movements": "Movements",

    // Campaign File Detail Labels
    "campaignFileDetail.Company": "Company:",
    "campaignFileDetail.Filename": "Filename:",
    "campaignFileDetail.Status": "Status:",
    "campaignFileDetail.Records": "Records:",
    "campaignFileDetail.LoadingStats": "Loading campaign statistics...",
    "campaignFileDetail.ErrorStats": "Error loading campaign statistics.",
    "campaignFileDetail.CampaignStatistics": "Campaign Statistics",

    // Campaign File Detail DataGrid Column Headers
    "campaignFileDetail.column.id": "ID",
    "campaignFileDetail.column.lineNumber": "Line#",
    "campaignFileDetail.column.email": "Email",
    "campaignFileDetail.column.firstName": "First name",
    "campaignFileDetail.column.lastName": "Last name",
    "campaignFileDetail.column.fullName": "Full name",
    "campaignFileDetail.column.phone": "Phone",
    "campaignFileDetail.column.status": "Status",
    "campaignFileDetail.column.updateDate": "Update Date",
    "campaignFileDetail.column.error": "Error",
    "campaignFileDetail.column.idDescriptor": "Id Descriptor",
    "campaignFileDetail.column.idCampaign": "Id Campaign",
    "campaignFileDetail.column.viewEvents": "View Events",

    // Spend Rules Config Labels
    "spendRulesConfig.AddSpendRule": "Add Spend Rule",
    "spendRulesConfig.ManageMccCodes": "Manage MCC Codes",

    // Spend Rules Config DataGrid Column Headers
    "spendRulesConfig.column.employerName": "Employer",
    "spendRulesConfig.column.ruleName": "Rule Name",
    "spendRulesConfig.column.accessType": "Access Type",
    "spendRulesConfig.column.ruleTargetName": "Rule Target Name",
    "spendRulesConfig.column.targetType": "Target Type",
    "spendRulesConfig.column.mccList": "MCC List",
    "spendRulesConfig.column.changeRequest": "Change Request",
    "spendRulesConfig.column.status": "Status",
    "spendRulesConfig.column.action": "Action",

    // Payroll Deduction Details Labels
    "payrollDeductionDetails.Company": "Company:",
    "payrollDeductionDetails.Status": "Status:",
    "payrollDeductionDetails.TotalAmount": "Total Amount:",
    "payrollDeductionDetails.PayPeriod": "Pay Period:",
    "payrollDeductionDetails.Loading": "Loading...",
    "payrollDeductionDetails.Error":
      "An error ocurred, please try again later...",

    // Payroll Deduction Details DataGrid Column Headers
    "payrollDeductionDetails.column.id": "ID",
    "payrollDeductionDetails.column.idMember": "Member ID",
    "payrollDeductionDetails.column.firstName": "First name",
    "payrollDeductionDetails.column.lastName": "Last name",
    "payrollDeductionDetails.column.amount": "Amount",
    "payrollDeductionDetails.column.status": "Status",
    "payrollDeductionDetails.column.creationDate": "Creation Date",
    "payrollDeductionDetails.column.periodStartDate": "Period Start Date",
    "payrollDeductionDetails.column.periodEndDate": "Period End Date",

    // Manage Groups Labels
    "manageGroups.ManageGroupMembers": "Manage Group Members",
    "manageGroups.AddCompanyGroup": "Add Company Group",
    "manageGroups.CompanyGroups": "Company groups",
    "manageGroups.AddGroup": "Add Group",
    "manageGroups.ErrorUpdating": "Error updating the company group",
    "manageGroups.ErrorDeleting": "Error deleting the attribute",

    // Manage Groups DataGrid Column Headers
    "manageGroups.column.id": "id",
    "manageGroups.column.name": "Group Name",
    "manageGroups.column.membersCount": "Members",
    "manageGroups.column.action": "Action",

    // Payment Descriptors Config Labels
    "paymentDescriptorsConfig.AddPaymentDescriptor": "Add Payment Descriptor",
    "paymentDescriptorsConfig.Loading": "Loading payment descriptors...",
    "paymentDescriptorsConfig.PaymentDescriptors": "Payment Descriptors",
    "paymentDescriptorsConfig.ErrorLoading":
      "Error loading payment descriptors",
    "paymentDescriptorsConfig.ErrorUpdating":
      "Error updating the payment descriptor",
    "paymentDescriptorsConfig.ErrorDeleting":
      "Error deleting the payment descriptor",
    "paymentDescriptorsConfig.UpdateSuccess":
      "Payment descriptor updated successfully",
    "paymentDescriptorsConfig.DeleteSuccess":
      "Payment descriptor deleted successfully",

    // Action button labels
    "paymentDescriptorsConfig.SaveChanges": "Save Changes",
    "paymentDescriptorsConfig.CancelChanges": "Cancel Changes",
    "paymentDescriptorsConfig.Approve": "Approve",
    "paymentDescriptorsConfig.Reject": "Reject",
    "paymentDescriptorsConfig.Activate": "Activate",
    "paymentDescriptorsConfig.Deactivate": "Deactivate",
    "paymentDescriptorsConfig.Delete": "Delete",

    // Payment Descriptors Config DataGrid Column Headers
    "paymentDescriptorsConfig.column.employerName": "Employer",
    "paymentDescriptorsConfig.column.descriptorId": "Descriptor ID",
    "paymentDescriptorsConfig.column.description": "Description",
    "paymentDescriptorsConfig.column.status": "Status",
    "paymentDescriptorsConfig.column.createdBy": "Created By",
    "paymentDescriptorsConfig.column.createdDate": "Created Date",
    "paymentDescriptorsConfig.column.updatedBy": "Updated By",
    "paymentDescriptorsConfig.column.updatedDate": "Updated Date",
    "paymentDescriptorsConfig.column.action": "Action",

    // Payments Labels
    "payments.title": "Payment Details",
    "payments.exportDetails": "Export Details",
    "payments.downloading": "Downloading...",
    "payments.downloadSuccess": "The file was download succesfully",
    "payments.downloadError": "There was an error trying to download the file",
    "payments.error": "An error ocurred, please try again later...",

    // Payments DataGrid Column Headers
    "payments.column.id": "ID",
    "payments.column.memberId": "Member Id",
    "payments.column.email": "Email",
    "payments.column.amount": "Amount",
    "payments.column.fullName": "Name",
    "payments.column.status": "Status",
    "payments.column.updateDate": "Update Date",
    "payments.column.idDescriptor": "Descriptor",
    "payments.column.location": "Location",
    "payments.column.filename": "Batch Id",
    "payments.column.error": "Error",
    "payments.column.changeLocation": "Change Location",

    // Query Balance Labels
    "queryBalance.CurrentBalance": "Current Balance",
    "queryBalance.CreditsThisMonth": "Credits this month",
    "queryBalance.CreditsThisWeek": "Credits this week",
    "queryBalance.CreditsToday": "Credits today",
    "queryBalance.DebitsThisMonth": "Debits this month",
    "queryBalance.DebitsThisWeek": "Debits this week",
    "queryBalance.DebitsToday": "Debits today",
    "queryBalance.Movements": "Movements",

    // Movements Labels
    "movements.DownloadSuccess": "The file was download succesfully",
    "movements.DownloadError": "There was an error trying to download the file",
    "movements.Credits": "Credits",
    "movements.Debits": "Debits",
    "movements.All": "All",
    "movements.Downloading": "Downloading...",
    "movements.ExportBalanceMovements": "Export Balance Movements",
    "movements.Error": "An error ocurred, please try again later...",
    "movements.DateFrom": "Date from:",
    "movements.DateTo": "Date to:",
    "movements.ChangeLocation": "Change Location",
    "movements.PaymentBatchDetails": "Payment Batch Details",

    // Movements DataGrid Column Headers
    "movements.column.id": "ID",
    "movements.column.movementDate": "Date",
    "movements.column.movementType": "Type",
    "movements.column.description": "Description",
    "movements.column.reference": "Reference",
    "movements.column.amount": "Amount",
    "movements.column.details": "Details",

    // Locations Labels
    "locations.Title": "Locations",
    "locations.Loading": "Loading...",
    "locations.Error": "An error ocurred, please try again later...",
    "locations.NewLocation": "New Location",
    "locations.Create": "Create",
    "locations.CreateLocationTitle": "Create a Location",
    "locations.CreateLocationDescription":
      "To create a location, input the address information and click create button.",

    // Locations DataGrid Column Headers
    "locations.column.id": "ID",
    "locations.column.description": "Description",
    "locations.column.address": "Address",
    "locations.column.inventoryManager": "Inventory Manager",
    "locations.column.phone": "Phone",

    // Payroll Deductions Stand Alone Labels
    "payrollDeductionsStandAlone.Title": "PAD Standalone (Payroll Deduction)",
    "payrollDeductionsStandAlone.DetailTitle": "Payroll Deduction Detail",
    "payrollDeductionsStandAlone.MarkAsPaid": "Mark as Paid",
    "payrollDeductionsStandAlone.ConfirmTitle":
      "Confirm the Payroll Deduction is Paid",
    "payrollDeductionsStandAlone.ConfirmContent":
      "To confirm the payroll deduction is paid, type invoice # or transaction # and click CONFIRM button.",

    // Payroll Deductions Stand Alone DataGrid Column Headers
    "payrollDeductionsStandAlone.column.id": "id",
    "payrollDeductionsStandAlone.column.employer": "Employer",
    "payrollDeductionsStandAlone.column.status": "Status",
    "payrollDeductionsStandAlone.column.amount": "Amount",
    "payrollDeductionsStandAlone.column.creationDate": "Creation Date",
    "payrollDeductionsStandAlone.column.periodStartDate": "Period Start Date",
    "payrollDeductionsStandAlone.column.periodEndDate": "Period End Date",
    "payrollDeductionsStandAlone.column.actions": "Actions",

    // Onboarding File Detail Labels
    "onboardingFileDetail.Loading": "Loading...",
    "onboardingFileDetail.Error": "An error ocurred, please try again later...",
    "onboardingFileDetail.Company": "Company:",
    "onboardingFileDetail.Filename": "Filename:",
    "onboardingFileDetail.Status": "Status:",
    "onboardingFileDetail.NumberOfRecords": "Number Of Records:",

    // Onboarding File Detail DataGrid Column Headers
    "onboardingFileDetail.column.id": "ID",
    "onboardingFileDetail.column.email": "Email",
    "onboardingFileDetail.column.firstName": "First name",
    "onboardingFileDetail.column.lastName": "Last name",
    "onboardingFileDetail.column.phone": "Phone",
    "onboardingFileDetail.column.ssn": "SSN",
    "onboardingFileDetail.column.lastFour": "Last four",
    "onboardingFileDetail.column.status": "Status",
    "onboardingFileDetail.column.error": "Error",
    "onboardingFileDetail.column.updateDate": "Update Date",

    // Assigned Cards Labels
    "assignedCards.Title": "Cards assigned",
    "assignedCards.Downloading": "Downloading...",
    "assignedCards.ExportButton": "Export Assigned Cards",
    "assignedCards.Locations": "Locations",
    "assignedCards.ProductType": "Product Type",
    "assignedCards.DateFrom": "Date from:",
    "assignedCards.DateTo": "Date to",
    "assignedCards.ProductPaycard": "Paycard",
    "assignedCards.PaycardDescription":
      "Standard paycard for payroll distribution",
    "assignedCards.ProductCorporateExpense": "Corporate Expense",
    "assignedCards.CorporateExpenseDescription":
      "Card for managing corporate expenses",
    "assignedCards.ProductIncentive": "Incentive",
    "assignedCards.IncentiveDescription":
      "Rewards and incentives program cards",
    "assignedCards.AllProducts": "All Products",
    "assignedCards.AllProductsDescription": "Show cards of all product types",
    "assignedCards.Upgrade": "Recard",
    "assignedCards.Error": "An error ocurred, please try again later...",
    "assignedCards.AssignedCardDetailTitle": "Assigned Card Detail",
    "assignedCards.SecureInfoCardDetailTitle": "Secure Info Card Detail",

    // Assigned Cards DataGrid Column Headers
    "assignedCards.column.id": "ID",
    "assignedCards.column.last4": "Last 4",
    "assignedCards.column.accountInfo": "Account Info",
    "assignedCards.column.memberNo": "Member No.",
    "assignedCards.column.memberInfo": "Member Info",
    "assignedCards.column.location": "location",
    "assignedCards.column.productType": "Product Type",
    "assignedCards.column.assignedOn": "Assigned On",
    "assignedCards.column.details": "Details",
    "assignedCards.column.actions": "Actions",

    // Dashboard Locations Labels
    "dashboardLocations.CardsDistribution": "Cards Distribution by Location",
    "dashboardLocations.Available": "Available",
    "dashboardLocations.column.location": "Location",
    "dashboardLocations.column.availableCards": "Available cards",
    "dashboardLocations.column.assignedCards": "Assigned cards",

    // Inter Company Transfer Labels
    "interCompanyTransfer.Title": "Inter Company Transfer",
    "interCompanyTransfer.ErrorLoadingBalances":
      "Error loading balances. Please try again.",
    "interCompanyTransfer.SourceBalance": "Source Balance",
    "interCompanyTransfer.DestinationBalance": "Destination Balance",
    "interCompanyTransfer.Processing": "Processing Transfer...",
    "interCompanyTransfer.Submit": "Submit Transfer",
    "interCompanyTransfer.GenericError":
      "An error occurred while processing the transfer.",
    "interCompanyTransfer.PermissionError":
      "You don't have permission to perform this transfer.",
    "interCompanyTransfer.InvalidRequest": "Invalid transfer request.",
    "interCompanyTransfer.ServerError": "Server error. Please try again later.",
    "interCompanyTransfer.Error": "Error",
    "interCompanyTransfer.UnknownError": "Unknown error",
    "interCompanyTransfer.NetworkError":
      "Network error. Please check your connection and try again.",
    "interCompanyTransfer.UnexpectedError": "An unexpected error occurred.",

    // Bundles Labels
    "bundles.PageTitle": "Cards Requested",
    "bundles.RequestCardsButton": "Request Cards",
    "bundles.ErrorMessage": "An error ocurred, please try again later...",
    "bundles.RequestVerifiedSuccess": "The request was verified succesfully",
    "bundles.OrderDeletedSuccess": "The order was deleted succesfully",
    "bundles.FileDownloadSuccess": "The file was download succesfully",
    "bundles.FileDownloadError":
      "There was an error trying to download the file",
    "bundles.ViewDialogTitle": "View Card Order Request",
    "bundles.RequestDialogTitle": "Request Cards",
    "bundles.RequestDialogText":
      "To request cards, input the information and click request button.",
    "bundles.DiscardDialogTitle": "Discard Request",
    "bundles.DiscardDialogText":
      "To discard this request, type the reason and click DISCARD button.",
    "bundles.ConfirmDialogTitle": "Confirm Order",
    "bundles.ConfirmDialogText":
      "To confirm the order, type order confirmation number and click CONFIRM button.",

    // Bundles Column Headers
    "bundles.column.id": "ID",
    "bundles.column.employer": "Employer",
    "bundles.column.description": "Description",
    "bundles.column.location": "Location",
    "bundles.column.count": "Count",
    "bundles.column.loadAmount": "Load Amount",
    "bundles.column.embossLine1": "Emboss Line 1",
    "bundles.column.embossLine2": "Emboss Line 2",
    "bundles.column.updateDate": "Update Date",
    "bundles.column.status": "Status",
    "bundles.column.action": "Action",
    "bundles.column.notes": "Notes",
    "bundles.column.createdBy": "Created By",

    // Bundles Tooltips
    "bundles.ViewTooltip": "Click to view more info of the request",
    "bundles.VerifyTooltip": "Click to verify and accept the request",
    "bundles.CancelTooltip": "Click to cancel and close the request",
    "bundles.ActivateTooltip": "Click to activate the cards",
    "bundles.DeleteTooltip": "Click to delete the request",
    "bundles.DownloadTooltip": "Click to download the CSV file from the order",
    "bundles.ConfirmationTooltip": "Click to enter the confirmation number",

    // Bundle Detail Labels
    "bundleDetail.EmailSentSuccess": "The request was sent",
    "bundleDetail.noEmail": "No Email",
    "bundleDetail.loading": "Loading...",
    "bundleDetail.bundleId": "Bundle ID:",
    "bundleDetail.lastUpdated": "Last updated:",
    "bundleDetail.status": "Status:",
    "bundleDetail.location": "Location:",
    "bundleDetail.cardsCount": "Cards count:",
    "bundleDetail.totalAmount": "Total Amount:",
    "bundleDetail.description": "Description:",
    "bundleDetail.resendEmailTooltip": "Resend the virtual card email",

    // Bundle Detail Column Headers
    "bundleDetail.column.id": "id",
    "bundleDetail.column.cardType": "Card Type",
    "bundleDetail.column.identifier": "Identifier",
    "bundleDetail.column.user": "User",
    "bundleDetail.column.status": "Status",
    "bundleDetail.column.action": "Action",
    "bundleDetail.column.cardInfo": "Card Info",
    "bundleDetail.column.amount": "Amount",
    "bundleDetail.column.descriptor": "Descriptor",
    "bundleDetail.column.error": "Error",

    // Assign Paycard Labels
    "assignPaycard.Title": "Assign card",
    "assignPaycard.CardInformation": "Card information",
    "assignPaycard.MemberInformation": "Member/Worker information",
    "assignPaycard.AddressInformation": "Address information",
    "assignPaycard.CardAssignedSuccess": "card assigned succesfully",
    "assignPaycard.ErrorGettingInfo": "There was an error getting the info",
    "assignPaycard.NoEmailWarning":
      "The members without email won't have access to EWA, Send Money nor Bill Pay",
    "assignPaycard.CardLast4Numbers": "Card last 4 numbers",
    "assignPaycard.MemberHasNoEmail": "Member has no email",
    "assignPaycard.VerifiedEmail": "Verified email",
    "assignPaycard.NoEmail": "No email",
    "assignPaycard.MemberCode": "Member code",
    "assignPaycard.FirstName": "First Name",
    "assignPaycard.MiddleInitial": "Middle Initial",
    "assignPaycard.LastName": "Last Name",
    "assignPaycard.MobilePhone": "Mobile Phone",
    "assignPaycard.DOB": "DOB",
    "assignPaycard.SSN": "SSN or ITIN",
    "assignPaycard.Language": "Language",
    "assignPaycard.English": "English",
    "assignPaycard.Spanish": "Spanish",
    "assignPaycard.LoadValueLabel": "Please enter the load value for the card",
    "assignPaycard.AddLocation": "Add a location",
    "assignPaycard.AddressLine1": "Address line 1",
    "assignPaycard.AddressLine2": "Address line 2",
    "assignPaycard.City": "City",
    "assignPaycard.State": "State",
    "assignPaycard.ZipCode": "Zip Code",
    "assignPaycard.Assign": "Assign",
    "assignPaycard.Processing": "Processing...",

    // SpendRulesConfig Additional Labels
    "spendRulesConfig.title": "Spend Rules",
    "spendRulesConfig.AddRule": "Add Rule",
    "spendRulesConfig.UpdateSuccess": "Spend rule updated successfully",
    "spendRulesConfig.UpdateError": "Error updating the spend rule",
    "spendRulesConfig.DeleteSuccess": "Spend rule deleted successfully",
    "spendRulesConfig.DeleteError": "Error deleting the spend rule",
    "spendRulesConfig.VerifySuccess": "The request was verified successfully",
    "spendRulesConfig.VerifyTooltip": "Click to verify and accept the request",
    "spendRulesConfig.CancelTooltip": "Click to cancel and close the request",

    // CreatePayFile Labels
    "createPayFile.title": "Create Pay File",
    "createPayFile.selectIndividuals": "Select Individuals to Pay",
    "createPayFile.defineAmounts": "Define Payment Amounts",
    "createPayFile.confirmGenerate": "Confirm and Generate Payfile",
    "createPayFile.memberList": "Member list",
    "createPayFile.members": "Members",
    "createPayFile.summary": "Summary",
    "createPayFile.unloadFile": "This is an unload file",
    "createPayFile.numberIndividuals":
      "Number of individuals to {action}: {count}",
    "createPayFile.totalAmount": "Total amount {unload}: {amount}",
    "createPayFile.process": "PROCESS",
    "createPayFile.close": "Close",
    "createPayFile.back": "Back",
    "createPayFile.next": "Next",
    "createPayFile.errorSelectIndividuals":
      "Please select at least one individual to pay",
    "createPayFile.errorFillAmount":
      "Please fill the amount for each individual",
    "createPayFile.errorFillDescriptor":
      "Please fill the descriptor for each individual",
    "createPayFile.errorMixDescriptors":
      "Not allowed to mix descriptors with -1 with other descriptors",
    "createPayFile.errorAmountRange": "Amount must be between 0 and 25000",
    "createPayFile.uploadSuccess": "file uploaded succesfully",

    // CreatePayFile DataGrid Column Headers
    "createPayFile.column.id": "ID",
    "createPayFile.column.companyId": "Company ID",
    "createPayFile.column.memberId": "Member Id",
    "createPayFile.column.email": "Email",
    "createPayFile.column.name": "Name",
    "createPayFile.column.amount": "Amount",
    "createPayFile.column.descriptor": "Descriptor",

    // UploadEwaCollectionAttempts Labels
    "uploadEwaCollectionAttempts.title": "Upload EWA Collection Attempts File",
    "uploadEwaCollectionAttempts.uploadFileTitle": "Please upload the CSV file",
    "uploadEwaCollectionAttempts.dragAndDropHere": "> DRAG AND DROP HERE <",
    "uploadEwaCollectionAttempts.uploadButton": "Upload",
    "uploadEwaCollectionAttempts.uploadSuccess": "file uploaded succesfully",

    // StartedOnboardings Labels
    "startedOnboardings.title": "OnBoarding Applications",
    "startedOnboardings.loading": "Loading...",
    "startedOnboardings.error": "An error ocurred, please try again later...",
    "startedOnboardings.requestSent": "The request was sent",
    "startedOnboardings.editDialogTitle": "Edit Onboarding",
    "startedOnboardings.resendEmailTooltip": "Resend the email to {email}",

    // StartedOnboardings DataGrid Column Headers
    "startedOnboardings.column.id": "ID",
    "startedOnboardings.column.memberId": "Member Id",
    "startedOnboardings.column.companyId": "Company Id",
    "startedOnboardings.column.firstName": "First Name",
    "startedOnboardings.column.lastName": "Last Name",
    "startedOnboardings.column.email": "Email",
    "startedOnboardings.column.dob": "DOB",
    "startedOnboardings.column.address": "Address",
    "startedOnboardings.column.phone": "Phone",
    "startedOnboardings.column.ssn": "SSN",
    "startedOnboardings.column.action": "Action",
    "startedOnboardings.column.duration": "Duration",
    "startedOnboardings.column.creationDate": "Creation Date",
    "startedOnboardings.column.updateDate": "Update Date",

    // BulkOnboarding Labels
    "bulkOnboarding.title": "Bulk Onboardings",
    "bulkOnboarding.uploadButton": "Upload Onboarding File",
    "bulkOnboarding.uploadDialogTitle": "Upload Onboarding File",
    "bulkOnboarding.detailDialogTitle": "Onboarding File Detail",

    // BulkOnboarding DataGrid Column Headers
    "bulkOnboarding.column.id": "id",
    "bulkOnboarding.column.employerName": "Employer",
    "bulkOnboarding.column.filename": "Filename",
    "bulkOnboarding.column.processStatus": "Status",
    "bulkOnboarding.column.numOfRecords": "Number of records",
    "bulkOnboarding.column.viewDetails": "View Details",

    // ManageOrganizationalUnit Labels
    "manageOrganizationalUnit.title": "Organizational Units",
    "manageOrganizationalUnit.addUnit": "Add Unit",
    "manageOrganizationalUnit.editUnit": "Edit Unit",

    // ManageOrganizationalUnit DataGrid Column Headers
    "manageOrganizationalUnit.column.id": "ID",
    "manageOrganizationalUnit.column.parentCompanyName": "Employer",
    "manageOrganizationalUnit.column.name": "Unit Name",
    "manageOrganizationalUnit.column.description": "Description",
    "manageOrganizationalUnit.column.address": "Address",
    "manageOrganizationalUnit.column.status": "Status",
    "manageOrganizationalUnit.column.action": "Action",

    // QueryAssignedPaycards Labels
    "queryAssignedPaycards.cardsAvailableToAssign": "Cards available to assign",
    "queryAssignedPaycards.totalCardsAssigned": "Total Cards assigned",
    "queryAssignedPaycards.cardsAssignedThisWeek": "Cards assigned this week",
    "queryAssignedPaycards.cardsAssignedToday": "Cards assigned today",

    // QueryMissingTimeAttendance Labels
    "queryMissingTimeAttendance.title": "Missing Time and Attendance",
    "queryMissingTimeAttendance.loading": "Loading...",
    "queryMissingTimeAttendance.error":
      "An error ocurred, please try again later...",

    // QueryMissingTimeAttendance DataGrid Column Headers
    "queryMissingTimeAttendance.column.id": "ID",
    "queryMissingTimeAttendance.column.transactionDate": "Transaction Date",
    "queryMissingTimeAttendance.column.transactionDescription": "Description",
    "queryMissingTimeAttendance.column.email": "Email",
    "queryMissingTimeAttendance.column.firstName": "First Name",
    "queryMissingTimeAttendance.column.lastName": "Last Name",
    "queryMissingTimeAttendance.column.memberId": "Member Id",
    "queryMissingTimeAttendance.column.companyName": "Company Name",
    "queryMissingTimeAttendance.column.amount": "Amount",

    // MissingTimeAttendance Labels
    "missingTimeAttendance.title": "Missing Time and Attendance",
    "missingTimeAttendance.loading": "Loading...",
    "missingTimeAttendance.error":
      "An error ocurred, please try again later...",

    // MissingTimeAttendance DataGrid Column Headers
    "missingTimeAttendance.column.id": "ID",
    "missingTimeAttendance.column.transactionDate": "Transaction Date",
    "missingTimeAttendance.column.transactionDescription": "Description",
    "missingTimeAttendance.column.email": "Email",
    "missingTimeAttendance.column.firstName": "First Name",
    "missingTimeAttendance.column.lastName": "Last Name",
    "missingTimeAttendance.column.memberId": "Member Id",
    "missingTimeAttendance.column.companyName": "Company Name",
    "missingTimeAttendance.column.amount": "Amount",

    // PayAnyDayAdvances Labels
    "payAnyDayAdvances.title": "Pay Any Day Advances",

    // PayAnyDayAdvances DataGrid Column Headers
    "payAnyDayAdvances.column.id": "ID",
    "payAnyDayAdvances.column.transactionDate": "Transaction Date",
    "payAnyDayAdvances.column.amount": "Amount",
    "payAnyDayAdvances.column.periodStartDate": "Start Date",
    "payAnyDayAdvances.column.periodEndDate": "End Date",
    "payAnyDayAdvances.column.pending": "Pending",

    // PayAnyDayPaybacks Labels
    "payAnyDayPaybacks.title": "Pay Any Day Paybacks",

    // PayAnyDayPaybacks DataGrid Column Headers
    "payAnyDayPaybacks.column.id": "ID",
    "payAnyDayPaybacks.column.transactionDate": "Transaction Date",
    "payAnyDayPaybacks.column.amount": "Amount",

    // Members Labels
    "members.title": "Members",
    "members.viewMemberInfo": "View Member Info",
    "members.changeLocation": "Change Location",
    "members.changeEmail": "Change Email",
    "members.error": "An error ocurred, please try again later...",

    // Members DataGrid Column Headers

    // Members DataGrid Column Headers
    "members.column.id": "ID",
    "members.column.memberId": "Member Id",
    "members.column.name": "Name",
    "members.column.contactInfo": "Contact Info",
    "members.column.createdAt": "Created At",
    "members.column.cardType": "Card Type",
    "members.column.orderStatus": "Order Status",
    "members.column.enrollStatus": "Enroll Status",
    "members.column.userStatus": "User status",
    "members.column.actions": "Actions",
    "members.column.changeLocation": "Change Location",

    // Assign Paycard Validation Messages
    "assignPaycard.validation.enterFirstName": "Enter the member First name",
    "assignPaycard.validation.firstNameNoSpaces":
      "First name should not contain spaces",
    "assignPaycard.validation.firstNameRequired": "First name is required",
    "assignPaycard.validation.enterMiddle": "Enter the member middle",
    "assignPaycard.validation.enterLastName": "Enter the member Last name",
    "assignPaycard.validation.lastNameNoSpaces":
      "Last name should not contain spaces",
    "assignPaycard.validation.lastNameRequired": "Last name is required",
    "assignPaycard.validation.selectLanguage": "Select the prefered language",
    "assignPaycard.validation.languageRequired":
      "Prefered Language is required",
    "assignPaycard.validation.enterAddressLine1":
      "Enter the member Address Line 1",
    "assignPaycard.validation.addressLine1Required":
      "Address line 1 is required",
    "assignPaycard.validation.enterAddressLine2":
      "Enter the member Address Line 2",
    "assignPaycard.validation.enterCity": "Enter the member city",
    "assignPaycard.validation.cityRequired": "City is required",
    "assignPaycard.validation.enterState": "Enter the member state",
    "assignPaycard.validation.stateLength":
      "State should be exactly 2 characters",
    "assignPaycard.validation.stateNotValid": "State is not valid",
    "assignPaycard.validation.stateRequired": "State is required",
    "assignPaycard.validation.enterZipCode": "Enter the member zip code",
    "assignPaycard.validation.zipRequired": "zip is required",
    "assignPaycard.validation.amountRequired": "Amount is required",
    "assignPaycard.validation.amountNonNegative": "Amount cannot be negative",
    "assignPaycard.validation.amountMin": "Min amount is 10",
    "assignPaycard.validation.amountMax": "Max amount is 500",
    "assignPaycard.validation.enterEmail": "Enter the member email",
    "assignPaycard.validation.validEmail": "Enter a valid email",
    "assignPaycard.validation.emailRequired": "Email is required",
    "assignPaycard.validation.cardNumberDigits":
      "Must be the last 4 digits of the card",
    "assignPaycard.validation.cardNumberRequired":
      "Card 4 last digits are required",
    "assignPaycard.validation.lastFourSSN": "Must be the last four of the SSN",
    "assignPaycard.validation.ssnRequired": "SSN is required",
    "assignPaycard.validation.validSSN": "Must be a valid SSN or ITIN",
    "assignPaycard.validation.enterPhone": "Enter the member mobile phone",
    "assignPaycard.validation.validPhone": "Enter a valid phone number",
    "assignPaycard.validation.phoneRequired": "Mobile phone is required",
    "assignPaycard.validation.birthdayRequired": "Birthday is required",
    "assignPaycard.validation.enterEmployeeCode": "Enter the employee code",
    "assignPaycard.validation.employeeCodeRequired":
      "Employee code is required",
  },
};

export default labels;
